import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["logo"]
  static values = {
    darkLogo: String,
    lightLogo: String
  }

  connect() {
    const savedTheme = localStorage.getItem("auth-theme") || "dark"
    this.applyTheme(savedTheme)
  }

  toggle() {
    const currentTheme = this.element.dataset.theme || "dark"
    const newTheme = currentTheme === "dark" ? "light" : "dark"
    localStorage.setItem("auth-theme", newTheme)
    this.applyTheme(newTheme)
  }

  applyTheme(theme) {
    this.element.dataset.theme = theme

    if (this.hasLogoTarget) {
      this.logoTarget.src = theme === "dark" ? this.darkLogoValue : this.lightLogoValue
    }
  }
}
